export default {
  labelStyles: {
    margin: "1rem 0 0 0",
  },
};
